export default __webpack_public_path__ + "static/media/office1-before1-1920w.12469929.avif";